export default __webpack_public_path__ + "static/media/regulatory--lane-control--g1.ebf113b6.png";